import React from 'react';
import topBanner from '../Assets/img/topBanner.png';
import { Link } from 'react-router-dom';

const TermsAndConditions = () => {
  return (
    <>
      <div className='row'>
        <div className='col-md-12'>
          <Link to={`/`} className='btn btn-success btn-sm'>
            <img src={topBanner} alt='Banner' style={{ width: '100%' }} />
          </Link>
        </div>
      </div>

      <div className='container mt-4'>
        <h2>Terms & Conditions</h2>
        <p>
          Welcome to <strong>Juice@Home</strong>. By placing an order or using our services, you agree to the following terms and conditions. Please read them carefully.
        </p>

        <h5 className="mt-3">1. Service Overview</h5>
        <ul>
          <li>We produce and deliver fresh juice to residential apartments and gated societies.</li>
          <li>All juices are made fresh daily and delivered based on your selected time slot and availability.</li>
        </ul>

        <h5 className="mt-4">2. Order Placement & Cancellation</h5>
        <ul>
          <li>Orders must be placed at least 12 hours in advance to ensure fresh preparation and smooth delivery.</li>
          <li>You may cancel orders as per our <Link to="/pages/CancellationandRefund">Cancellation & Refund Policy</Link>.</li>
        </ul>

        <h5 className="mt-4">3. Pricing & Payment</h5>
        <ul>
          <li>All prices are inclusive of applicable taxes.</li>
          <li>Payments can be made online using UPI, cards, or net banking through secure gateways.</li>
          <li>Cash-on-delivery may be available at select locations, subject to confirmation.</li>
        </ul>

        <h5 className="mt-4">4. Delivery</h5>
        <ul>
          <li>We aim to deliver within your chosen time slot, but delays may occur due to traffic or unforeseen circumstances.</li>
          <li>We are not responsible for failed deliveries due to incorrect address or unavailability of the customer.</li>
        </ul>

        <h5 className="mt-4">5. Quality & Complaints</h5>
        <ul>
          <li>If you face any issue with the juice quality or service, please contact us immediately at <strong>info@erelatelabs.com</strong>.</li>
          <li>We reserve the right to investigate and provide refunds or replacements where applicable.</li>
        </ul>

        <h5 className="mt-4">6. Modifications</h5>
        <ul>
          <li>We reserve the right to update these terms and conditions at any time. Updated terms will be posted on this page.</li>
        </ul>

        <p className="mt-3">
          Your continued use of our services constitutes your agreement to our current terms.
        </p>
      </div>
    </>
  );
};

export default TermsAndConditions;
